// Firmen-Mailsysteme setzen Banner vor Antworten: Klassifizierung („AIRBUS AMBER",
// „TLP:GREEN", „Classification: Internal"), Extern-Hinweise („[EXTERNAL]",
// „CAUTION: This email originated from outside …") und Microsofts Erstkontakt-Hinweis
// („Sie erhalten nicht häufig E-Mails von …"). In Vorschau und Kurztext lasen sich
// die wie der Anfang der Antwort (Befund 28.09.2026: „AIRBUS AMBER Guten Tag, …").
//
// Entfernt wird nur am Anfang, nur was eindeutig ein Banner ist; der vollständige
// Wortlaut bleibt unverändert. Funktioniert auch auf bereits zusammengezogenem
// Kurztext (lastLine), weil gespeicherte Karten keinen Zeilenumbruch mehr haben.

const TLP = '(?:AMBER|GREEN|RED|WHITE|CLEAR)(?:\\+STRICT)?';
// Ohne „TLP:" nur, wenn danach die Zeile endet oder die Anrede beginnt —
// „OK GREEN light" bleibt Text.
const GREETING = '(?:Guten|Hallo|Hi|Hello|Dear|Sehr|Liebe|Lieber|Moin|Servus|Grüß|Good)\\b';

const BANNERS: readonly RegExp[] = [
  // „TLP:AMBER", „AIRBUS AMBER" — bis zu drei Großbuchstaben-Wörter davor.
  new RegExp(`^TLP\\s*:\\s*${TLP}(?![\\p{L}])`, 'u'),
  new RegExp(
    `^(?:[A-ZÄÖÜ][A-ZÄÖÜ0-9&.-]*[ \\t]+){1,3}${TLP}(?=[ \\t]*(?:\\n|$)|\\s+${GREETING})`,
    'u',
  ),
  /^(?:Classification|Klassifizierung|Klassifikation|Sensitivity|Vertraulichkeit)\s*:\s*\S+(?:\s+(?:Use|Only|General))*/i,
  /^\[\s*(?:EXTERNAL|EXTERN|EXTERNE?\s+E-?MAIL|External Email|External Sender)\s*\]\s*:?/i,
  /^(?:EXTERNAL|EXTERN)\s*(?:E-?MAIL)?\s*:/,
  /^(?:Einige Personen, die diese Nachricht erhalten haben, erhalten|Sie erhalten) nicht (?:häufig|oft) E-Mails von .{0,200}?wichtig ist\s*(?:<[^>]*>|\[[^\]]*\])?\.?/i,
  /^(?:Some people who received this message don't|You don't) often get email from .{0,200}?important\s*(?:<[^>]*>|\[[^\]]*\])?\.?/i,
];

// „CAUTION: This email originated from outside …": nur, wenn danach wirklich
// von dieser Mail/diesem Absender die Rede ist. Entfernt wird der erste Satz,
// dazu der zweite, wenn er die übliche Klick-Warnung ist (ganze Wörter).
const WARNING = /^(?:CAUTION|WARNING|ACHTUNG|VORSICHT|WARNUNG)\s*:\s*/i;
const ABOUT_MAIL =
  /^(?:This (?:e-?mail|message)|Diese (?:E-?Mail|Nachricht)|Die(?:se)? E-?Mail|External (?:e-?mail|sender)|Externe[rn]? (?:E-?Mail|Absender))\b[^.]{0,160}?\b(?:outside|extern\w*|außerhalb|originated)\b/i;
const CLICK_WARNING = /\b(?:safe|sicher|vertrauenswürdig|recognize|kennen|trust)\b/i;

function warningBanner(text: string): string | null {
  const prefix = text.match(WARNING)?.[0];
  if (!prefix || !ABOUT_MAIL.test(text.slice(prefix.length))) return null;
  const [first, second] = text.slice(0, 500).split(/(?<=[.!])\s+/);
  if (!first || !/[.!]$/.test(first)) return null;
  return second && CLICK_WARNING.test(second) && /[.!]$/.test(second)
    ? text.slice(0, text.indexOf(second) + second.length)
    : first;
}

export function autopilotStripMailBanner(text: string): string {
  let rest = String(text ?? '').trimStart();
  for (let guard = 0; guard < 6; guard++) {
    const banner = BANNERS.map((re) => rest.match(re)?.[0]).find(Boolean);
    if (banner) {
      rest = rest.slice(banner.length).trimStart();
      continue;
    }
    const warning = warningBanner(rest);
    if (warning) {
      rest = rest.slice(warning.length).trimStart();
      continue;
    }
    break;
  }
  return rest;
}
